export default {
    // namespaced: true,
    state: {
        user: {},
        cartNum: '', //此读者的购物车书量
        institution: '' // 详情页链接地址名称
    },
    mutations: {
        setUser(state, value) {
            state.user = value;
        },
        setCartNum(state, value) {
            state.cartNum = value;
        },
        setInstitution(state, value) {
            state.institution = value;
        },
    },
    actions: {},
}
